/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  fetchServices,
  setSelectedService,
  submitLoanApplication,
  clearSubmitStatus,
  fetchCustomerByUserId,
  clearCustomer,
} from "../redux/slices/loan/ApplyLoanSlice";
import "../assets/Loan/PersonalLoanForm.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";

const normalizeFrequency = (value = "") => {
  const v = String(value).trim().toLowerCase();

  if (["day", "days", "daily"].includes(v)) return "daily";

  if (["week", "weeks", "weekly"].includes(v)) return "weekly";

  if (["bi-weekly", "biweekly", "fortnightly", "fortnight"].includes(v))
    return "bi-weekly";

  if (["month", "months", "monthly"].includes(v)) return "monthly";

  if (["quarter", "quarters", "quarterly"].includes(v)) return "quarterly";

  if (
    [
      "half-yearly",
      "half yearly",
      "halfyearly",
      "semiannual",
      "semi-annual",
    ].includes(v)
  )
    return "half-yearly";

  if (["year", "years", "yearly", "annual"].includes(v)) return "yearly";

  return "";
};

const FREQUENCY_MAP = {
  daily: 365,
  weekly: 52,
  "bi-weekly": 26,
  monthly: 12,
  quarterly: 4,
  "half-yearly": 2,
  yearly: 1,
};

export default function FixedLoanForm() {
  const dispatch = useDispatch();
  const {
    services,
    selectedService,
    loading,
    error,
    submitStatus,
    customer,
    loanResponse,
  } = useSelector((state) => state.applyLoan);
  const { profile } = useSelector((state) => state.userProfile);

  console.log("cusotmer", customer);

  // -------------------- States --------------------
  const [loanScheme, setLoanScheme] = useState("");
  const [availableSchemes, setAvailableSchemes] = useState([]);
  const [loanAmount, setLoanAmount] = useState("");
  const [totalLoanAmount, setTotalLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [loanEMIAmount, setLoanEMIAmount] = useState("");
  const [loanInterest, setLoanInterest] = useState(0);
  const [loanPayable, setLoanPayable] = useState(0);
  const [fees, setFees] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [formData, setFormData] = useState({
    fixedLoanFrequency: "",
    loanDisbursalMode: "",
    loanAppliedDate: "",
    loanPurpose: "",
    collectionLandmark: "",
    approvalDate: "",
    disbursalDate: "",
    status: "Pending",
    kycStatus: "Verified",
    fullName: "",
    branchCode: "BR001",
    mobileNumber: "",
    aadhaarNumber: "",
    panNumber: "",
    guarantorName: "",
    guarantorMobile: "",
    guarantorAadhaar: "",
    guarantorPAN: "",
    guarantorRelation: "",
    guarantorImageFile: null,
  });

  // -------------------- Fetch profile & services --------------------
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile?.superAdminId) {
      dispatch(fetchServices(String(profile.superAdminId)));
    }
  }, [dispatch, profile]);

  const fixedLoan = services.filter((s) =>
    s?.serviceType?.toLowerCase().includes("fixed"),
  );
  //  console.log(fixedLoan[0].serviceType)

  // -------------------- Prefill customer data --------------------
  useEffect(() => {
    if (selectedCustomer) {
      setFormData((prev) => ({
        ...prev,
        fullName: selectedCustomer.fullName || "",
        mobileNumber: selectedCustomer.mobileNumber || "",
        aadhaarNumber: selectedCustomer.aadhaarNumber || "",
        panNumber: selectedCustomer.panNumber || "",
        bankAccountNumber: selectedCustomer.bankAccount || "",
        ifsc: selectedCustomer.bankIFSC || "",
        guardianName: selectedCustomer.guardianName || "",
        address: selectedCustomer.address || "",
      }));
    } else if (!formData.userId) {
      setFormData({
        userId: "",
        fullName: "",
        mobileNumber: "",
        aadhaarNumber: "",
        panNumber: "",
        bankAccountNumber: "",
        ifsc: "",
        guardianName: "",
        address: "",
      });
    }
  }, [selectedCustomer, formData.userId]);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`https://payyug.in/api/customers`, {
        params: {
          branchId: profile.id || 8,
          // superAdminId: profile.superAdminId || 14,
          page: 1,
          limit: 1000,
        },
      });
      setCustomers(res.data.data || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to fetch customers");
    }
  };

  useEffect(() => {
    if (profile) fetchCustomers();
  }, [profile]);

  const handleUserIdChange = (e) => {
    const userId = e.target.value;
    setFormData((prev) => ({ ...prev, userId }));
    if (userId.length >= 5) {
      dispatch(fetchCustomerByUserId(userId));
    } else {
      dispatch(clearCustomer());
    }
  };

  const handleNonZeroInput = (value, setter) => {
    const val = Number(value);
    if (val > 0) setter(val);
    else setter("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // -------------------- Loan Schemes --------------------
  useEffect(() => {
    const filtered = services.filter(
      (s) =>
        s.serviceType?.toLowerCase().includes("fixed") &&
        s.schemeStatus.toLowerCase() === "active",
    );

    setAvailableSchemes(filtered);
  }, [services]);

  useEffect(() => {
    if (loanScheme) dispatch(setSelectedService(loanScheme));
    else dispatch(setSelectedService(null));
  }, [loanScheme, dispatch]);

  useEffect(() => {
    const fetchFees = async () => {
      try {
        if (!profile?.superAdminId || !selectedService?.id) return;

        console.log("API Calling with service:", selectedService.id);

        const res = await fetch(
          `https://payyug.in/api/all-fee-master?superadminId=${profile.superAdminId}&applicableOn=Disbursal&service=${selectedService.id}`,
        );

        const data = await res.json();
        console.log("fees response", data);

        if (data.success) {
          setFees(data.data || []);
        }
      } catch (error) {
        console.error("Error fetching fees:", error);
      }
    };

    fetchFees();
  }, [profile?.superAdminId, selectedService?.id]);

  useEffect(() => {
    let tempVar = 0;

    fees.forEach((fee) => {
      if (fee.type === "Percentage") {
        tempVar += (loanAmount * fee.value) / 100;
      } else if (fee.type === "Fixed") {
        tempVar += fee.value;
      }
    });

    setTotalLoanAmount(Number(loanAmount) + tempVar);
  }, [loanAmount, fees]);

  // useEffect(() => {
  //   const principal = Number(loanAmount);
  //   const emi = Number(loanEMIAmount);
  //   const tenure = Number(loanTenure);

  //   if (principal > 0 && emi > 0 && tenure > 0) {
  //     const payable = emi * tenure;

  //     const interest = payable - principal;

  //     setLoanPayable(payable);

  //     setLoanInterest(interest > 0 ? interest : 0);
  //   } else {
  //     setLoanPayable(0);
  //     setLoanInterest(0);
  //   }
  // }, [loanAmount, loanEMIAmount, loanTenure]);

 const calculateLoanDetails = ({
  principal,
  tenure,
  tenureType,
  recoveryFrequency,
  emi,
}) => {
  const tenureFreq = normalizeFrequency(tenureType);
  const recoveryFreq = normalizeFrequency(recoveryFrequency);

  const tenurePerYear = FREQUENCY_MAP[tenureFreq];
  const recoveryPerYear = FREQUENCY_MAP[recoveryFreq];

  if (
    !principal ||
    !tenure ||
    !emi ||
    !tenurePerYear ||
    !recoveryPerYear
  ) {
    return null;
  }

  const installmentCount = Math.round(
    (Number(tenure) * recoveryPerYear) / tenurePerYear
  );


  const payable =
    Number(emi) * installmentCount;

  const interest =
    payable - Number(principal);

  return {
    installmentCount,
    payable: Number(payable.toFixed(2)),
    interest: Number(
      Math.max(0, interest).toFixed(2)
    ),
  };
};

 useEffect(() => {
  if (
    !loanAmount ||
    !loanTenure ||
    !loanEMIAmount ||
    !selectedService
  ) {
    setLoanInterest(0);
    setLoanPayable(0);
    return;
  }

  const result = calculateLoanDetails({
    principal: loanAmount,
    tenure: loanTenure,
    tenureType: selectedService?.tenureType,
    recoveryFrequency:
      selectedService?.recoveryFrequency,
    emi: loanEMIAmount,
  });

  if (!result) return;

  setLoanInterest(result.interest);
  setLoanPayable(result.payable);
}, [
  loanAmount,
  loanTenure,
  loanEMIAmount,
  selectedService,
]);

  // -------------------- Submit Loan --------------------
  const handleSubmit = (e) => {
    e.preventDefault();

        if (
          !formData.guarantorName ||
          !formData.guarantorMobile ||
          !formData.guarantorAadhaar ||
          !formData.guarantorImageFile||
          !formData.guarantorPAN
        ) {
          toast.error("Please fill guarantor details");
          return;
        }

    if (Number(loanAmount) < Number(selectedService?.minAmount)) {
      toast.error(
        `Loan Amount cannot be less than ₹${selectedService?.minAmount}`,
      );
      return;
    }

    if (Number(loanAmount) > Number(selectedService?.maxAmount)) {
      toast.error(`Loan Amount cannot exceed ₹${selectedService?.maxAmount}`);
      return;
    }

    if (Number(loanTenure) > Number(selectedService?.maxTenure)) {
      toast.error(`Maximum Tenure allowed is ${selectedService?.maxTenure}`);
      return;
    }

    if (!loanScheme || !formData.fullName || !formData.loanAppliedDate) {
      toast.warn("Please fill all required fields!");
      return;
    }

    const payload = {
      userId: localStorage.getItem("userId"),
      superAdminId: profile.superAdminId,
      userName: formData.fullName,
      loanType: fixedLoan[0]?.serviceType || "Fixed Loan",
      loanService: loanScheme,
      branchCode: formData.branchCode || "BR001",
      minLoanAmount: selectedService?.minAmount || 0,
      maxLoanAmount: selectedService?.maxAmount || 0,
      loanRoi: Number(selectedService?.roi) || 0,
      loanRecoveryFrequency: selectedService?.recoveryFrequency || "",
      schemeId: selectedService?.id || 0,
      tenuretype: selectedService?.tenureType || "",
      roiferequency: selectedService?.roiFrequency || "",
      loanRoiType: selectedService?.roiType || "",
      prefix: selectedService?.prefix || "",
      loanAmount: loanAmount || 0,
      loanTenure: loanTenure || 0,
      loanEmiAmount: loanEMIAmount || 0,
      loanDisbursalMode: formData.loanDisbursalMode,
      loanAppliedDate: new Date(formData.loanAppliedDate)
        .toISOString()
        .split("T")[0],
      loanInterest: loanInterest,
      loanPayable: loanPayable,
      loanPurpose: formData.loanPurpose,
      collectionLandmark: formData.collectionLandmark,
      status: "Pending",
      kycStatus: "Verified",
      customerId: selectedCustomer?.userId || formData.userId,
      mobileNumber: formData.mobileNumber,
      aadhar: formData.aadhaarNumber,
      panNumber: formData.panNumber,
      bankAccountNumber: formData.bankAccountNumber,
      ifsc: formData.ifsc,
      guardianName: formData.guardianName,
      address: formData.address,
      guarantorName: formData.guarantorName,
      guarantorMobile: formData.guarantorMobile,
      guarantorAadhaar: formData.guarantorAadhaar,
      guarantorPAN: formData.guarantorPAN,
      guarantorRelation: formData.guarantorRelation,
    };

    console.log("Submitting loan payload:", payload);
    toast.success("Loan Apply Successfully.");
    dispatch(submitLoanApplication(payload));
  };

  useEffect(() => {
    if (submitStatus === "succeeded" && loanResponse?.data) {
      console.log("✅ Loan success, triggering nominee API...");

      const loanId =
        loanResponse.data?.id ||
        loanResponse.data?.loanId ||
        loanResponse.data?.data?.id;

      if (!loanId) {
        toast.error("Loan ID missing — cannot create nominee.");
        return;
      }

      const createNominee = async () => {
        try {
          const nomineeForm = new FormData();
          nomineeForm.append("guarantorName", formData.guarantorName);
          nomineeForm.append("guarantorMobile", formData.guarantorMobile);
          nomineeForm.append("guarantorAadhar", formData.guarantorAadhaar);
          nomineeForm.append("panNumber", formData.guarantorPAN);
          nomineeForm.append("relationApplicant", formData.guarantorRelation);
          nomineeForm.append("loanId", loanId);
          nomineeForm.append("branchId", profile?.id || null);
          nomineeForm.append("superAdminId", profile?.superAdminId || null);
          nomineeForm.append("customerId", selectedCustomer?.userId);

          if (formData.guarantorImageFile) {
            nomineeForm.append("file", formData.guarantorImageFile);
          }

          toast.info("Creating nominee, please wait...");

          const res = await fetch("https://payyug.in/api/nominee-crated", {
            method: "POST",
            body: nomineeForm,
          });

          const data = await res.json();

          if (res.ok) {
            toast.success(
              data?.message || "✅ Loan and Nominee submitted successfully!",
            );
            resetForm(); // 🔥 C
            dispatch(clearSubmitStatus()); // Optional - reset redux status
          } else {
            console.error(
              `❌ Nominee creation failed: ${data?.message || "Error"}`,
            );
          }
        } catch (err) {
          console.error("🚨 Error submitting nominee:", err);
          toast.error("Error submitting nominee!");
        }
      };

      createNominee();
    }
  }, [submitStatus, loanResponse, formData, profile]);

  // console.log("selected service ", selectedService);
  // -------------------- Render --------------------

  const resetForm = () => {
    setLoanScheme("");
    setAvailableSchemes([]);
    setLoanAmount("");
    setLoanTenure("");
    setLoanEMIAmount(0);
    setLoanInterest(0);
    setLoanPayable(0);
    setSelectedCustomer(null);
    setFormData({
      fixedLoanFrequency: "",
      loanDisbursalMode: "",
      loanAppliedDate: "",
      loanPurpose: "",
      collectionLandmark: "",
      approvalDate: "",
      disbursalDate: "",
      status: "Pending",
      kycStatus: "Verified",
      fullName: "",
      branchCode: "BR001",
      mobileNumber: "",
      aadhaarNumber: "",
      panNumber: "",
      guarantorName: "",
      guarantorMobile: "",
      guarantorAadhaar: "",
      guarantorPAN: "",
      guarantorRelation: "",
      guarantorImageFile: null,
      userId: "",
      bankAccountNumber: "",
      ifsc: "",
      guardianName: "",
      address: "",
    });
  };

  return (
    <div className="PersonalLoanForm-container">
      <h1>Fixed Loan Application Form</h1>
      {(loading || submitStatus === "loading") && (
        <div className="loader-overlay">
          <ClipLoader size={60} color="#3498db" />
        </div>
      )}

      <form className="PersonalLoanForm-form" onSubmit={handleSubmit}>
        {/* Loan Options */}
        <section className="PersonalLoanForm-section">
          <h2>Loan Options & Schemes</h2>
          <div className="PersonalLoanForm-loan-options">
            <div className="PersonalLoanForm-form-group">
              <label>Loan Type</label>

              <input value={fixedLoan[0]?.serviceType || "Fixed"} readOnly />
            </div>
            <div className="PersonalLoanForm-form-group">
              <label>Fixed Loan Scheme</label>
              <select
                value={loanScheme}
                onChange={(e) => setLoanScheme(e.target.value)}
                disabled={!availableSchemes.length}
                required
              >
                <option value="">Select Scheme</option>
                {availableSchemes.map((s) => (
                  <option key={s.serviceName} value={s.serviceName}>
                    {s.serviceName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>

        {/* Loan Details */}
        <section className="PersonalLoanForm-section">
          <h2>Loan Details</h2>
          <div className="PersonalLoanForm-loan-details-grid">
            <div className="PersonalLoanForm-form-group">
              <label>Minimum Loan Amount</label>

              <input value={selectedService?.minAmount || ""} readOnly />
            </div>
            <div className="PersonalLoanForm-form-group">
              <label>Maximum Loan Amount</label>

              <input value={selectedService?.maxAmount || ""} readOnly />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Interest Rate (%)</label>
              <input value={selectedService?.roi || ""} readOnly />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>ROI Frequency</label>
              <input value={selectedService?.roiFrequency} readOnly />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Recovery Frequency</label>
              <input value={selectedService?.recoveryFrequency} readOnly />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Max Tenure</label>
              <input value={selectedService?.maxTenure} readOnly />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Loan Amount</label>
              <input
                type="number"
                value={loanAmount}
                placeholder="Enter Loan Amount"
                onChange={(e) => setLoanAmount(e.target.value)}
                required
              />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Tenure ({selectedService?.tenureType})</label>

              <input
                type="number"
                value={loanTenure}
                placeholder="Enter Tenure"
                onChange={(e) => setLoanTenure(e.target.value)}
                required
              />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>EMI Amount</label>
              <input
                type="number"
                value={loanEMIAmount}
                placeholder="Enter EMI Amount"
                onChange={(e) => setLoanEMIAmount(e.target.value)}
                required
              />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Interest Amount</label>

              <input value={loanInterest} readOnly />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Total Payable</label>

              <input value={loanPayable} readOnly />
            </div>

            {[
              {
                id: "loanDisbursalMode",
                label: "Loan Disbursal Mode",
                options: ["Bank Transfer", "Cheque", "Cash"],
              },
            ].map(({ id, label, options }) => (
              <div className="PersonalLoanForm-form-group" key={id}>
                <label htmlFor={id}>{label}</label>
                <select
                  id={id}
                  name={id}
                  value={formData[id] || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select {label}
                  </option>
                  {options.map((o) => (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <div className="PersonalLoanForm-form-group">
              <label htmlFor="loanAppliedDate">Loan Applied Date</label>
              <input
                type="date"
                id="loanAppliedDate"
                name="loanAppliedDate"
                value={formData.loanAppliedDate || ""}
                onChange={handleChange}
              />
            </div>

            <div className="PersonalLoanForm-form-group ">
              <label htmlFor="loanPurpose">Loan Purpose</label>
              <input
                type="text"
                id="loanPurpose"
                name="loanPurpose"
                placeholder="Reason or description"
                value={formData.loanPurpose || ""}
                onChange={handleChange}
              />
            </div>

            <div className="PersonalLoanForm-form-group ">
              <label htmlFor="collectionLandmark">Collection Landmark</label>
              <input
                type="text"
                id="collectionLandmark"
                name="collectionLandmark"
                placeholder="Enter collection landmark (e.g., Near Post Office)"
                value={formData.collectionLandmark || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

        {/* User Details */}
        <section className="PersonalLoanForm-section">
          <h2>User Details</h2>
          <div className="PersonalLoanForm-form-group">
            <label>Customer ID</label>
            {/* <input
              type="text"
              name="userId"
              value={formData.userId || ""}
              onChange={handleUserIdChange}
              placeholder="Enter Customer ID"
              required
            /> */}
            <Select
              className="account-select-container"
              classNamePrefix="account-select"
              placeholder="Search by Name or A/C No..."
              options={customers.map((cus) => ({
                value: cus.id,
                label: `${cus.userId} | ${cus.fullName}`,
                customerDetail: cus,
              }))}
              value={
                selectedCustomer
                  ? {
                      value: selectedCustomer.id,
                      label: `${selectedCustomer.userId} | ${selectedCustomer.fullName}`,
                    }
                  : null
              }
              onChange={(selected) =>
                setSelectedCustomer(selected?.customerDetail)
              }
              isSearchable
            />
          </div>

          <div className="PersonalLoanForm-loan-details-grid">
            {[
              { id: "fullName", label: "Full Name" },
              { id: "mobileNumber", label: "Mobile Number" },
              { id: "aadhaarNumber", label: "Aadhaar Number" },
              { id: "panNumber", label: "PAN Number" },
              { id: "bankAccountNumber", label: "Bank Account Number" },
              { id: "ifsc", label: "IFSC" },
              { id: "guardianName", label: "Guardian Name" },
              { id: "address", label: "Address" },
            ].map(({ id, label }) => (
              <div className="PersonalLoanForm-form-group" key={id}>
                <label>{label}</label>
                <input
                  type="text"
                  name={id}
                  value={formData[id] || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [id]: e.target.value,
                    }))
                  }
                />
              </div>
            ))}
          </div>
        </section>

        {/* Guarantor */}
        <section className="PersonalLoanForm-section">
          <h2>Guarantor Details</h2>
          <div className="PersonalLoanForm-loan-details-grid">
            {[
              { id: "guarantorName", label: "Guarantor Name" },
              { id: "guarantorMobile", label: "Mobile Number" },
              { id: "guarantorAadhaar", label: "Aadhaar Number" },
              { id: "guarantorPAN", label: "PAN Number" },
              { id: "guarantorRelation", label: "Relation with Applicant" },
            ].map(({ id, label }) => (
              <div key={id} className="PersonalLoanForm-form-group">
                <label>{label}</label>
                <input
                  type="text"
                  name={id}
                  value={formData[id] || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [id]: e.target.value,
                    }))
                  }
                />
              </div>
            ))}
            <div className="PersonalLoanForm-form-group">
              <label>Guarantor Photo</label>
              <input
                type="file"
                // required
                accept="image/*"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    guarantorImageFile: e.target.files[0],
                  }))
                }
              />
            </div>
          </div>

          {formData.guarantorImageFile && (
            <img
              src={URL.createObjectURL(formData.guarantorImageFile)}
              alt="Preview"
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "10px",
                objectFit: "cover",
                marginTop: "10px",
              }}
            />
          )}
        </section>
        <div className="PersonalLoanForm-submit-wrapper">
          <button
            type="submit"
            className="PersonalLoanForm-apply-btn"
            disabled={submitStatus === "loading"}
          >
            {submitStatus === "loading" ? "Submitting..." : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
}
